import { Box, Button, Stack, Typography } from "@mui/material"
import { useRef } from "react"
import { Bound } from "lib/@components/binding/Bound"
import { BoundTextEditor } from "minimals-template/components/editor"

export function ChangeItemEditor({ initialText, onSave, onCancel }) {
    const target = useRef({ text: initialText ?? "" }).current

    return (
        <Stack spacing={0.5}>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ minHeight: 28 }}>
                <Typography variant="caption" color="text.secondary">
                    Proposed
                </Typography>
                <Button
                    variant="text"
                    size="small"
                    onClick={onCancel}
                    sx={{ minWidth: 0, p: 0.25, fontSize: "0.7rem" }}
                >
                    Cancel
                </Button>
                <Button
                    variant="text"
                    size="small"
                    color="primary"
                    onClick={save}
                    sx={{ minWidth: 0, p: 0.25, fontSize: "0.7rem" }}
                >
                    Save
                </Button>
            </Stack>
            <Box sx={{ border: "1px solid", borderColor: "primary.light", borderRadius: 1, overflow: "hidden" }}>
                <Bound target={target}>
                    <BoundTextEditor field="text" label="" />
                </Bound>
            </Box>
        </Stack>
    )

    function save() {
        onSave(target.text)
    }
}
